<app-new-note [moduleId]="moduleId" [entityId]="staffId" [isCurrentUser]="true"></app-new-note>